import PropTypes from 'prop-types';
import React from 'react';

const ModalBody = ({ children }) => {
  return <div>{children}</div>;
};

ModalBody.propTypes = {
  children: PropTypes.node
};

export default ModalBody;
